import Delete from '@monofront/design-system/visuals/Icons/Old/Delete';
import Button from '@monofront/design-system/components/Button';
import { useShoppingCart } from '@hooks/cart/useShoppingCart';
import { IShoppingCartProduct } from '@monofront/types';
import { toast } from 'react-toastify';
import { tryit } from 'radash';
import { useTranslations } from 'next-intl';
import logger from '@utils/logger';

interface IButtonRemoveProductFromShoppingCartProps {
  product: IShoppingCartProduct;
}

const ButtonRemoveProductFromShoppingCart: React.FC<
  IButtonRemoveProductFromShoppingCartProps
> = ({ product }) => {
  const { shoppingCartId } = useShoppingCart();
  const { decrementProductInShoppingCart } = useShoppingCart();
  const et = useTranslations('Errors');

  const removeProductFromShoppingCart = async () => {
    try {
      if (!shoppingCartId) {
        throw new Error('Unexpected empty `shoppingCartId`');
      }

      const tryDecrementProductInShoppingCart = tryit(
        decrementProductInShoppingCart,
      );

      const [err] = await tryDecrementProductInShoppingCart(
        shoppingCartId,
        product,
      );

      if (err) {
        throw new Error('Error removing product from cart', { cause: err });
      }
    } catch (err: unknown) {
      toast.error(et('anErrorOccured'), {
        progressClassName: 'toast-error',
      });

      logger.error(err);
    }
  };

  return (
    <Button
      disabled={!shoppingCartId}
      variant="transparent"
      hasMinWidth={false}
      onClick={removeProductFromShoppingCart}
      dataTestId="ButtonRemoveProductFromShoppingCart-Button-1"
    >
      <Delete color="var(--black)" />
    </Button>
  );
};

export default ButtonRemoveProductFromShoppingCart;
